/**
 * @file 工具函数库
 * @author sakuramo <sakuramo@tencent.com>
 */

import { webpCheck } from './is';

// 部分原立即执行函数可使用本命令统一初始化
export const init = () => {
  webpCheck();
};

// @ts-ignore
// eslint-disable-next-line no-undef
export const version = __buildVersion__;

export * from './codec';
export * from './console';
export * from './datetime';
export * from './fmt';
export * from './image';
export * from './is';
export * from './object';
export * from './random';
export * from './regexp';
export * from './request';
export * from './storage'; // swr need test
export * from './ui';
export * from './url';
export * from './utils';
